import * as React from 'react';
import { forwardRef, Suspense } from 'react';
import { MonacoCodeEditorProps, MonacoRef } from './MonacoCodeEditor';
import { MonacoLoading } from './MonacoLoading';
import lazyRetry from '../../../lazyRetry';

// Store the import function so preload uses the SAME import
const importMonacoCodeEditor = () => import('./MonacoCodeEditor');

const LoadableEditor = lazyRetry(importMonacoCodeEditor, 'MonacoCodeEditor');

/**
 * Preload the MonacoCodeEditor component.
 * Call this early to avoid showing loading spinner later.
 * Safe to call multiple times - the import is cached.
 */
export const preloadMonacoEditor = () => {
  return importMonacoCodeEditor().catch(() => {
    // Silently ignore preload errors
  });
};

const LoadableMonacoEditor = forwardRef<MonacoRef, MonacoCodeEditorProps>((props, ref) => (
  <Suspense fallback={<MonacoLoading theme={props.theme} />}>
    <LoadableEditor {...{ ...props, ref }} />
  </Suspense>
));

export default LoadableMonacoEditor;
